import { create } from 'zustand';
import { KundliProfile } from '@services/kundliService';

interface KundliProfilesState {
    profiles: KundliProfile[];
    isLoading: boolean;
    lastFetchedAt: number | null;
    error: string | null;

    // Actions
    setProfiles: (profiles: KundliProfile[]) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
    markFetched: () => void;
    clearCache: () => void;

    // Helpers
    shouldRefetch: () => boolean;
    getDefaultProfile: () => KundliProfile | undefined;
}

// Cache validity duration: 5 minutes
const CACHE_DURATION = 5 * 60 * 1000;

export const useKundliProfilesStore = create<KundliProfilesState>((set, get) => ({
    profiles: [],
    isLoading: false,
    lastFetchedAt: null,
    error: null,

    setProfiles: (profiles) => set({ profiles, error: null }),

    setLoading: (isLoading) => set({ isLoading }),

    setError: (error) => set({ error }),

    markFetched: () => set({ lastFetchedAt: Date.now() }),

    clearCache: () => set({
        profiles: [],
        lastFetchedAt: null,
        error: null
    }),

    shouldRefetch: () => {
        const { lastFetchedAt, isLoading } = get();
        if (isLoading) return false;
        if (!lastFetchedAt) return true;
        return Date.now() - lastFetchedAt > CACHE_DURATION;
    },

    getDefaultProfile: () => {
        const { profiles } = get();
        return profiles.find(p => p.is_default) || profiles[0];
    },
}));
